import { BranchDetailsIdDataInput } from './branch-details-id-data-input.model';
import { VehicleTypeIdDataInput } from './vehicle-type-id-data-input.model';


export class SelectByCompanyIdBranchIdAndVehicleTypeIdInput implements ISelectByCompanyIdBranchIdAndVehicleTypeIdInput {
    /** The auto-generated id of the company details master */
    companyDetailId!: number;
    branchDetailsIdData!: BranchDetailsIdDataInput[];
    vehicleTypeIdData!: VehicleTypeIdDataInput[];

    constructor(data?: ISelectByCompanyIdBranchIdAndVehicleTypeIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailId = _data["companyDetailId"];
            if (Array.isArray(_data["branchDetailsIdData"])) {
                this.branchDetailsIdData = [] as any;
                for (let item of _data["branchDetailsIdData"])
                    this.branchDetailsIdData!.push(BranchDetailsIdDataInput.fromJS(item));
            }
            if (Array.isArray(_data["vehicleTypeIdData"])) {
                this.vehicleTypeIdData = [] as any;
                for (let item of _data["vehicleTypeIdData"])
                    this.vehicleTypeIdData!.push(VehicleTypeIdDataInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectByCompanyIdBranchIdAndVehicleTypeIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectByCompanyIdBranchIdAndVehicleTypeIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailId"] = this.companyDetailId;
        if (Array.isArray(this.branchDetailsIdData)) {
            data["branchDetailsIdData"] = [];
            for (let item of this.branchDetailsIdData)
                data["branchDetailsIdData"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleTypeIdData)) {
            data["vehicleTypeIdData"] = [];
            for (let item of this.vehicleTypeIdData)
                data["vehicleTypeIdData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISelectByCompanyIdBranchIdAndVehicleTypeIdInput {
    /** The auto-generated id of the company details master */
    companyDetailId: number;
    branchDetailsIdData: BranchDetailsIdDataInput[];
    vehicleTypeIdData: VehicleTypeIdDataInput[];
}

